import MessageInputAttachmentPreview from './MessageInputAttachmentPreview';

export default MessageInputAttachmentPreview;
